'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { reserveTransactionItems } from '@marketplace-web/messaging/conversation-messaging-data'

import GenericReservationDialog from './GenericReservationDialog'

type Props = {
  transactionId: number
  reserved: boolean
}

const SellerReserveAction = ({ transactionId, reserved }: Props) => {
  const translate = useTranslate()

  if (reserved) {
    return (
      <GenericReservationDialog
        onConfirm={async () => {
          await reserveTransactionItems(transactionId, false)
        }}
        buttonProps={{
          text: translate('conversation.hero_message.transaction_actions.unreserve'),
          testId: 'unreserve-button',
        }}
        dialogTranslationKeyPrefix="conversation.conversation_info.remove_reservation_modal"
      />
    )
  }

  return (
    <GenericReservationDialog
      onConfirm={async () => {
        await reserveTransactionItems(transactionId, true)
      }}
      buttonProps={{
        text: translate('conversation.hero_message.transaction_actions.reserve'),
        testId: 'reserve-button',
      }}
      dialogTranslationKeyPrefix="conversation.conversation_info.reserve_modal"
    />
  )
}

export default SellerReserveAction
